import { IsDefined, IsOptional, IsString, Length } from 'class-validator';
import { BaseDto } from '../base.dto';
import { Exclude } from 'class-transformer';

export class AclStockPermissionListUpdateDto extends BaseDto {
  @IsDefined()
  @IsString()
  @Length(1, 255)
  name: string;

  @IsOptional()
  @IsString()
  @Length(1, 500)
  tags: string;

  @Exclude()
  lastSharedDate: Date;
}
